var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 4.4 4.23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ed709d;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3.55,4.23H.87L.28.46h3.85l-.58,3.77ZM1.12,3.93h2.17l.49-3.18H.62l.5,3.18Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 0.46,
    width: 4.4,
    height: 0.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.91,
    y: 0.23,
    width: 2.57,
    height: 0.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2.05,
    width: 0.3,
    height: 0.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2.05,
    y: 0.73,
    width: 0.29,
    height: 3.31
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "2.96 3.96 2.67 3.93 3 .59 3.3 .62 2.96 3.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1.43 3.96 1.08 .62 1.37 .59 1.72 3.93 1.43 3.96"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashIcon);
export default __webpack_public_path__ + "static/media/trash-icon.994b29c43f3ad48c8041c5b878dcf4e7.svg";
export { ForwardRef as ReactComponent };